import { all, call, put, takeLatest } from 'redux-saga/effects'

import { getRequest } from 'api/apiUtils'
import * as currenciesActions from 'redux/currencies/currencies-actions'
import * as ledgerActions from 'redux/ledger/ledger-actions'
import ledgerActionTypes from 'redux/ledger/ledger-types'
import { IS_PRODUCTION } from 'utils/helperConfig'

import UserActionTypes from '../user/user-types'

import * as allAssetsActions from './allAssets-actions'
import allAssetsTypes from './allAssets-types'

function* startSwitchUserAccount() {
    yield put(allAssetsActions.finishGetQuickDepositAsset())
}
// When switching between accounts, need to clear quickDepositAsset
export function* onStartSwitchUserAccount() {
    yield takeLatest(UserActionTypes.FINISH_SWITCH_USER_ACCOUNT, startSwitchUserAccount)
}

function* successGetQuickDepositAsset({ payload }) {
    yield put(allAssetsActions.successGetQuickDepositAsset(payload))
}
// After successfully getting XCurrency, need to immediately update quickDepositAsset
export function* onSuccessGetQuickDepositAsset() {
    yield takeLatest(ledgerActionTypes.SUCCESS_FETCH_CURRENCIES_ID, successGetQuickDepositAsset)
}

function* fetchAllAssets() {
    try {
        yield put(currenciesActions.startGetCurrenciesFromAssets())
        const { data: assets } = yield getRequest('/user/assets')

        yield put(allAssetsActions.successFetchAllAssets(assets))
        yield put(currenciesActions.successGetCurrenciesFromAssets(assets))
    } catch (err) {
        yield put(allAssetsActions.failureFetchAllAssets())
        yield put(currenciesActions.failureGetCurrenciesFromAssets())
        if (!IS_PRODUCTION) {
            console.log('error fetchAllAssets', err?.response?.data)
        }
    }
}

export function* onStartFetchAllAssets() {
    yield takeLatest(allAssetsTypes.START_FETCH_ALL_ASSETS, fetchAllAssets)
}

function* fetchQuickDepositAsset({ payload }) {
    try {
        if (payload.type === 'XCurrency') {
            yield put(ledgerActions.startFetchLedgerCurrenciesId({ id: payload.identifier }))
        } else if (payload.type === 'Iban') {
            yield put(ledgerActions.fetchUserBankAccountsId({ id: payload.identifier }))
        }
    } catch (err) {
        yield put(allAssetsActions.failureGetQuickDepositAsset())
        if (!IS_PRODUCTION) {
            console.log('error fetchQuickDepositAsset', err?.response?.data)
        }
    }
}

export function* onStartGetQuickDepositAsset() {
    yield takeLatest(allAssetsTypes.START_GET_QUICK_DEPOSIT_ASSET, fetchQuickDepositAsset)
}

export function* allAssetsSagas() {
    yield all([
        call(onStartSwitchUserAccount),
        call(onSuccessGetQuickDepositAsset),
        call(onStartFetchAllAssets),
        call(onStartGetQuickDepositAsset),
    ])
}
